import { Routing } from "../shared/routing.js";
import { Localize } from "../shared/localize.js";

import { EncodeUrl, DecodeUrl, MapQueryStringToObject, ObjectToQueryString } from "../../utils/urls.js";

var validRoot = [Routing.R("cerchi"), Routing.R("cerchi-in-ferro"), Routing.R("ruote-complete")];
var redirectRoot = Routing.R("cerchi");

export function parseUrl()  {
  var url = location.pathname.toLowerCase();

  var ManufacturerName = null, ModelName = null, Year = null;
  var Diameters = null;

  const parsed = MapQueryStringToObject(window.location);

  if (url.substring(0, 1) == "/") {
    url = url.substring(1);

    url = url.split("/").map((u) => DecodeUrl(u));

    if (url[1] && url[1].indexOf(Localize.L("-pollici")) != -1) {
      Diameters = url[1] ? url[1].replace(Localize.L("-pollici"), "") : null;
      url[1] = "";
    }
    else {
      ManufacturerName = url[1] ? url[1] : null;
    }

    if (url[2] && url[2].indexOf(Localize.L("-pollici")) != -1) {
      Diameters = url[2] ? url[2].replace(Localize.L("-pollici"), "") : null;
      url[2] = "";
    }
    else {
      ModelName = url[2] ? url[2] : null;
    }

    if (url[3] && url[3].indexOf(Localize.L("-pollici")) != -1) {
      Diameters = url[3] ? url[3].replace(Localize.L("-pollici"), "") : null;
      url[3] = "";
    }
    else {
      Year = url[3] ? url[3] : null;
    }

    return {
      root: validRoot.includes(url[0]) ? url[0] : redirectRoot,
      segment: url.length - 1,
      maker: ManufacturerName,
      model: ModelName,
      year: Year,
      diameters: Diameters ? Diameters.replace(Localize.L("-pollici"), "") : (parsed.diameters ? parsed.diameters.replace(Localize.L("-pollici"), "") : null),
      chassis: parsed.chassis ? parsed.chassis : null,
      steeloralloy: parsed.steeloralloy,
      type: parsed.type ? parsed.type : null
    };
  }

  return null;
}

export function joinUrl(parsedUrl) {
  var url = null;

  if (parsedUrl) {
    var sep = "?";

    url = "/" + parsedUrl.root;

    if (url) {
      if (parsedUrl.maker) {
        url += "/" + EncodeUrl(parsedUrl.maker);

        if (parsedUrl.model) {
          url += "/" + EncodeUrl(parsedUrl.model);

          if (parsedUrl.year) {
            url += "/" + EncodeUrl(parsedUrl.year);

            if (parsedUrl.chassis) {
              url += sep + "chassis=" + parsedUrl.chassis.toLowerCase();
              sep = "&";
            }
            if (parsedUrl.type) {
              url += sep + "type=" + parsedUrl.type.toLowerCase();
              sep = "&";
            }
            if (parsedUrl.diameters) {
              url += sep + "diameters=" + parsedUrl.diameters.toLowerCase();
              sep = "&";
            }
          }
          else if (parsedUrl.diameters) {
            url += "/" + EncodeUrl(parsedUrl.diameters + Localize.L("-pollici"));
          }
        }
        else if (parsedUrl.diameters) {
          url += "/" + EncodeUrl(parsedUrl.diameters + Localize.L("-pollici"));
        }
      }
      else if (parsedUrl.diameters) {
        url += "/" + EncodeUrl(parsedUrl.diameters + Localize.L("-pollici"));
      }
    }

    if (parsedUrl.steeloralloy) {
      url += sep + "steeloralloy=" + parsedUrl.steeloralloy.toLowerCase();
    }
  }

  return url;
}
